import { renderMultipleModules } from 'client/javascript/util/geolocation_based_module_rendering/render_multiple_modules';
import { renderSingleUniqueModule } from 'client/javascript/util/geolocation_based_module_rendering/render_single_unique_module';

const VIDEO_CTA_MODULE_SELECTOR = '.video-cta';

export const showVideoCtaModuleByGeolocation = () => {
  renderMultipleModules({ selector: VIDEO_CTA_MODULE_SELECTOR });
};

export const setupVideoCtaModule = () => {
  renderSingleUniqueModule({ selector: VIDEO_CTA_MODULE_SELECTOR });
};
